import { dateUtil } from '@zto/zpage'

import { ActivityCycleType, YesNoStr } from '@/config'
import { formatDate2 } from '@/utils'

/** 获取活动时间描述 */
export function getActivitDateDesc(model: any) {
  if (!model) return '--'

  let { cycleType, cycleDay, monthLastExeFlag, febIgnoreFlag, febExeDay } = model

  febExeDay = febExeDay || []
  cycleDay = cycleDay || []

  let datePrefix = ''
  let dateStr = ''

  const startDateStr = model.startDate ? dateUtil.format(model.startDate, 'date') : '--'
  const endDateStr = formatDate2(model.endDate)

  switch (cycleType) {
    case ActivityCycleType.NONE:
      dateStr = `${startDateStr} ~ ${endDateStr}`
      break
    case ActivityCycleType.MONTH:
      datePrefix = '每月'
      if (monthLastExeFlag === YesNoStr.YES) {
        dateStr = '最后一天'
      } else if (cycleDay.length) {
        dateStr = cycleDay.map((it: any) => `${it}号`).join()
      }

      if (febIgnoreFlag === YesNoStr.YES) {
        dateStr += '，跳过二月'
      } else if (febExeDay.length) {
        dateStr += '，二月' + febExeDay.map((it: any) => `${it}号`).join()
      }
      break
    case ActivityCycleType.WEEK:
      datePrefix = '每周'

      if (cycleDay.length) {
        dateStr = cycleDay.map((it: any) => `周${it}`).join()
      }
      break
  }

  return `${datePrefix}${dateStr}` || '--'
}
